import { render } from "./MobileSignUp.vue?vue&type=template&id=987e599c&scoped=true&ts=true"
import script from "./MobileSignUp.vue?vue&type=script&lang=ts"
export * from "./MobileSignUp.vue?vue&type=script&lang=ts"

import "./MobileSignUp.vue?vue&type=style&index=0&id=987e599c&scoped=true&lang=less"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987e599c"]])

export default __exports__